import { ApartmentDto } from "@/api/models/coverage.model";

interface ApartmentState {
	apartment: ApartmentDto;
}

export const apartmentInitialState = () => {
	return {
		apartment: {
			apartmentId: "-1",
			floor: "",
			door: "",
			stair: "",
			network: ""
		} as ApartmentDto
	};
};

const state: ApartmentState = apartmentInitialState();
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
	state,
	actions,
	mutations,
	getters
};
